import React from 'react';

import useWindowSize from '@components/common/hooks/useWindowSize';
import { M_DEVICE } from '@components/lpc/Constants';
import Card from '@components/lpc/Pot/CreatePotLayout/PoolsTunnel/PotTypeSelection/Card/Card';

import css from './PotTypeSelection.module.scss';

const Types = {
    LPC: 'LPC',
    LPS: 'SOLIDARITY_POOL',
};

type PotTypeSelectionProps = {
    onSelectType: (type: string) => void;
    potCreationType: string;
};

const PotTypeSelection = ({ onSelectType, potCreationType }: PotTypeSelectionProps) => {
    const { width } = useWindowSize();

    const onSelectTypeEvent = (type: string) => {
        onSelectType(type);
    };

    return (
        <div className={css.pot_types}>
            <div className={css.pot_types__container}>
                <div onClick={() => onSelectTypeEvent(Types.LPC)}>
                    <Card
                        image={`lpc-img-pot-category.png`}
                        selected={potCreationType === Types.LPC}
                        cardType={Types.LPC}
                        selectedCreationType={potCreationType}
                        icon={width > M_DEVICE ? 'front-static/icons/navigation/caret-down-gray.svg' : ''}
                    />
                </div>
                <div onClick={() => onSelectTypeEvent(Types.LPS)}>
                    <Card
                        image={`lps-img-pot-category${width > M_DEVICE ? '' : '-mobile'}.png`}
                        selected={potCreationType === Types.LPS}
                        cardType={Types.LPS}
                        selectedCreationType={potCreationType}
                        icon={width > M_DEVICE ? 'front-static/icons/navigation/caret-down-gray.svg' : ''}
                    />
                </div>
            </div>
        </div>
    );
};
export default PotTypeSelection;
export { Types };
